import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { FETCH_STATUS } from '@Root/contants'
import { TAX_TYPE } from '@Root/contants/tax'
import { landTaxAxios } from '@Root/utils/landAxios'
import TaxInfo from '@Types/entities/TaxInfo'
import MyHouseTax from '@Types/entities/MyHouseTax'

export type MyHouseTaxState = {
  taxType: TAX_TYPE | null
  taxList: TaxInfo[] | null
  otherId: string | null
  fetchStatus: FETCH_STATUS
}

export const initialState: MyHouseTaxState = {
  taxType: null,
  taxList: null,
  otherId: null,
  fetchStatus: FETCH_STATUS.INITIAL,
} as MyHouseTaxState

export const fetchTax = createAsyncThunk('myhouse/tax', async () => await (await landTaxAxios.get(`myhouse/v2/tax`)).data)

const myhouseTaxSlice = createSlice({
  name: 'myhouseTax',
  initialState,
  reducers: {
    initializeTax: (state: MyHouseTaxState) => {
      Object.assign(state, initialState)
    },
    updateTaxType: (state: MyHouseTaxState, action: PayloadAction<TAX_TYPE>) => {
      state.taxType = action.payload
    },
    updateTaxList: (state: MyHouseTaxState, action: PayloadAction<MyHouseTax>) => {
      state.taxList = action.payload.taxInfoList
      state.otherId = action.payload.otherId
    },
    updateFetchStatus: (state: MyHouseTaxState, action: PayloadAction<FETCH_STATUS>) => {
      state.fetchStatus = action.payload
    },
  },
  extraReducers: {
    [fetchTax.pending.type]: (state: MyHouseTaxState, action: PayloadAction<MyHouseTax>) => {
      state.fetchStatus = FETCH_STATUS.PENDING
    },
    [fetchTax.fulfilled.type]: (state: MyHouseTaxState, action: PayloadAction<MyHouseTax>) => {
      state.taxList = action.payload.taxInfoList
      state.fetchStatus = FETCH_STATUS.SUCCESS

      const month = new Date().getMonth() + 1
      if (action.payload.otherId) {
        state.taxType = TAX_TYPE.OTHER_SERVICE_ID
        state.otherId = action.payload.otherId
      } else if (!action.payload.subscribed) {
        state.taxType = TAX_TYPE.NOT_APPLY_SERVICE
      } else if (action.payload.taxInfoList.length === 0) {
        if (month === 10) {
          state.taxType = TAX_TYPE.OUT_PAYMENT_PERIOD
        } else {
          state.taxType = TAX_TYPE.BEFORE_SENDING_BILL
        }
      } else {
        state.taxType = TAX_TYPE.DEFAULT
      }
    },
    [fetchTax.rejected.type]: (state: MyHouseTaxState, action: PayloadAction<MyHouseTax>) => {
      state.fetchStatus = FETCH_STATUS.FAILURE
    },
  },
})

export const { initializeTax, updateTaxType, updateTaxList, updateFetchStatus } = myhouseTaxSlice.actions
export default myhouseTaxSlice.reducer
